import { apiClient } from './client';
import { authEndpoints } from './authEndpoints';
import { userEndpoints } from './userEndpoints';
import { contributionEndpoints } from './contributionEndpoints';
import { adminEndpoints } from './adminEndpoints';
import { inviteEndpoints } from './inviteEndpoints';
import ownershipEndpoints from './ownershipEndpoints';
import dashboardEndpoints from './dashboardEndpoints';
import profitEntryEndpoints from './profitEntryEndpoints';
import allocationEndpoints from './allocationEndpoints';
import settlementEndpoints from './settlementEndpoints';
import withdrawalEndpoints from './withdrawalEndpoints';
import { statementEndpoints } from './statementEndpoints';
import { adminTreasuryEndpoints } from './adminTreasuryEndpoints';
import { paymentsEndpoints } from './paymentsEndpoints';

// Main API object with organized endpoints
export const api = {
  auth: authEndpoints,
  users: userEndpoints,
  contributions: contributionEndpoints,
  admin: adminEndpoints,
  invites: inviteEndpoints,
  ownership: ownershipEndpoints,
  dashboard: dashboardEndpoints,
  profitEntries: profitEntryEndpoints,
  allocations: allocationEndpoints,
  settlements: settlementEndpoints,
  withdrawals: withdrawalEndpoints,
  statements: statementEndpoints,
  treasury: adminTreasuryEndpoints,
  payments: paymentsEndpoints,
  
  // Direct access to client for custom requests
  client: apiClient,
};

// Export types
export * from './userEndpoints';
export * from './authEndpoints';
export * from './contributionEndpoints';
export * from './adminEndpoints';
export * from './inviteEndpoints';
export * from './ownershipEndpoints';
export * from './dashboardEndpoints';
export * from './profitEntryEndpoints';
export * from './allocationEndpoints';
export * from './settlementEndpoints';
export * from './withdrawalEndpoints';
export * from './dashboardEndpoints';
export * from './statementEndpoints';
export * from './adminTreasuryEndpoints';
export * from './paymentsEndpoints';

// Default export
export default api;
